'use strict';
// Editorial approval is a human review of distinct local value, not a word score.
function categorySeoIndexable({ editorialQualityApproved, total }) {
  return editorialQualityApproved === true && Number.isSafeInteger(total) && total > 0;
}
module.exports = { categorySeoIndexable };
